"use client";

import React, { useEffect, useState } from "react";
import styles from "./UpdateLogo.module.css";
import LogoAction from "./LogoAction";

interface UpdateLogoProps {
  initialData?: string;
  setSelectedFile(val: File | null): void;
}

const UpdateLogo = ({ setSelectedFile, initialData }: UpdateLogoProps) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (initialData) {
      setSelectedImage(initialData);
    }
  }, [initialData]);

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
      setError("File size exceeds 10 MB");
      setSelectedImage(null);
      return;
    }

    const validTypes = ["image/png", "image/jpg", "image/jpeg"];
    if (!validTypes.includes(file.type)) {
      setError("Invalid file type. Only PNG, JPG, and JPEG are allowed.");
      setSelectedImage(null);
      return;
    }

    setError(null);

    const imageUrl = URL.createObjectURL(file);
    setSelectedImage(imageUrl);
    setSelectedFile(file);
  };

  return (
    <div className={styles.updateLogoContainer}>
      <div className={styles.column4}>
        <div
          className={styles.image}
          style={{
            backgroundColor: !selectedImage ? "#FFE2EF" : "transparent",
          }}
        >
          {selectedImage && (
            <div className={styles.logoEditWrapper}>
              <img
                src={selectedImage}
                alt="Park logo"
                className={styles.logo}
              />
              <div className={styles.editPen}>
                <LogoAction
                  handleUpload={handleImageUpload}
                  imgUrl={selectedImage}
                />
              </div>
            </div>
          )}
        </div>
        {error && <div>{error}</div>}
      </div>
    </div>
  );
};

export default UpdateLogo;
